<div class="layout-content">
    <aside class="layout-sidebar" >
        <nav class="text-text-gray">
          <ng-container *ngFor="let menu of menuList">
            <div class="mb-6">
              <ol class="recon-menu">
                <div>
                 <li class="flex gap-2 items-center" role="button" [routerLink]="menu.link" [routerLinkActive]="'active-parent'">
                  <i [class]="menu.icon"></i>
                  <div class="poppins-medium">{{menu.label}}</div>
                 </li>
                 <ng-container *ngFor="let subMenu of menu.subMenu; let i =index">
                  <li class="ml-4 pl-4 menu-item" [routerLink]="subMenu.link" [routerLinkActive]="'active-child'">
                    <div role="button" class="poppins-regular" [ngClass]="i == 0 ? 'mt-4' : 'pt-4'">
                      {{subMenu.label}}
                    </div>
                  </li>
                 </ng-container>
                </div>
              </ol>
            </div>
          </ng-container>
        </nav>
    </aside>
    <main class="layout-content-slot">
        <div class="px-8">
          <router-outlet></router-outlet>
        </div>
    </main>
</div>
